import React from 'react';
import { ListingOtherSellerRootProps, HeaderProps, ListProps, ItemProps } from './types';
import { classNames } from './classNames';
import Header from './ListingOtherSellerHeader';
import List from './ListingOtherSellerList';
import Item from './ListingOtherSellerItem';

import Classes from './ListingOtherSellerRoot.module.scss';

const ListingOtherSeller: React.FC<ListingOtherSellerRootProps> & {
  Header: React.FC<HeaderProps>;
  List: React.FC<ListProps>;
  Item: React.FC<ItemProps>;
} = ({ children, className }) => {
  return (
    <div
      className={`${Classes[classNames.root]}${className ? ` ${className}` : ''}`}
      data-testid="listing-other-seller"
    >
      {children}
    </div>
  );
};

ListingOtherSeller.Header = Header;
ListingOtherSeller.List = List;
ListingOtherSeller.Item = Item;

export default ListingOtherSeller;
